import {createStrokeSVG} from './TEMPLATE'

// tabler: adjustments
export const SettingsSliderVertical_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0',
    'M6 4v4',
    'M6 12v8',
    'M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0',
    'M12 4v10',
    'M12 18v2',
    'M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0',
    'M18 4v1',
    'M18 9v11',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
